import React, { Fragment, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';
import { ptBR } from "date-fns/locale";

import {
    KeyboardTimePicker,
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Switch
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
        minWidth: 950,
        maxWidth: 900
    }
}));

const Create = ({ item, open, closeCreation, createValues, dependencies }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Novo Lote de Faturamento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                codigo: Yup.string().max(20).required('A seleção da unidade é obrigatório'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Box className={classes.fieldset} >


                                        <Grid
                                            container
                                            spacing={2}
                                            xs="auto"
                                        >
                                            <Grid
                                                item
                                                md={2}
                                                xs={2}>

                                                <NumberFormat
                                                    error={Boolean(touched.codigo && errors.codigo)}
                                                    fullWidth
                                                    label="Código"
                                                    margin="normal"
                                                    name="codigo"
                                                    id="codigo"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.codigo}
                                                    variant="outlined"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={7}
                                                xs={7}>

                                                <TextField
                                                    error={Boolean(touched.nome && errors.nome)}
                                                    fullWidth
                                                    label="Descrição"
                                                    margin="normal"
                                                    name="nome"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.nome}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={3}>

                                                <KeyboardDatePicker
                                                    fullWidth
                                                    required
                                                    cancelLabel="Cancelar"
                                                    margin="normal"
                                                    inputVariant="outlined"
                                                    id="dataCriacao"
                                                    label="Data de Criação"
                                                    format="DD/MM/YYYY"
                                                    name="dataCriacao"
                                                    value={values.dataCriacao}
                                                    onBlur={handleBlur}
                                                    onChange={value => setFieldValue("dataCriacao", value)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>


                                        </Grid>
                                

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
